export default {
  SaveSuccessMessage: "Lưu thành công",
  List: {
    AddButton: "Thêm mới",
    ExportListButton: "Xuất khẩu danh sách",
    ActionMulti: {
      UnSelect: "Bỏ chọn",
      SelectAll: "Chọn tất cả",
      UnSelectAll: "Bỏ chọn tất cả",
      SelectCount: "Đã chọn",
    },
    AddRole: "Thêm vai trò",
    SavePemission: "Lưu",
  },
  Search: {
    SearchPlaceHolder: "Tìm kiếm",
    AddButton: "Thêm mới",
    SubmitButton: "Chọn",
    CancelButton: "Hủy",
  },
  Message: {
    DeleteSuccess: "Xóa thành công.",
    DeleteArisened: "Dữ liệu đã có phát sinh, bạn không thể xóa.",
    ConfirmDeleteTitle: "Xóa {0}",
    ConfirmDelete: "Bạn có chắc chắn muốn xóa {0} <{1}> đã chọn không?",
    ConfirmDeleteMutiTitle: "Bạn có thực sự muốn xóa những <{0}> đã chọn không?",
    Error: "Có lỗi xảy ra vui lòng thử lại sau!",
    CopySuccess: "Copy dữ liệu thành công",
    SaveSuccess: "Cất thành công",
    AddAccountFailed: "Thêm tài khoản thất bại",
  },
  Validate: {
    Duplicate: "{0} <{1}> đã tồn tại trong danh sách. Xin vui lòng kiểm tra lại.",
    EditVersion: "Dữ liệu đã bị thay đổi bởi người dùng khác. Xin vui lòng nạp lại.",
    DeleteMultiHasMultiArisened: "Có một số bản ghi xuất hiện lỗi trong quá trình xóa.", // Chi tiết xem phía dưới: [ {0} ]
    DeleteMultiHasMultiArisened2: "Có một số bản ghi đã có phát sinh. Không thể xóa!",
    ConfirmDeleteMultiHasMultiArisened:
      "Có một số bản ghi đã có phát sinh. Bạn có muốn tiếp tục xóa không!",
    DeleteMultiHasOneArisened: "Có một bản ghi đã có phát sinh. Không thể xóa!", //<{0}>
    OverQuantity:
      "Bạn đã nhập số lượng <{0}> vượt quá số lượng tồn hiện có trên hệ thống. Vui lòng kiểm tra lại. ", //<{0}>
    UsageHistoryArise:
      "Đã phát sinh nghiệp vụ ngày <{0}>. Vui lòng xóa nghiệp vụ ngày <{0}> trước khi xóa nghiệp vụ.",
    NotPermission: "Bạn không có quyền thực hiện chức năng này. Vui lòng kiểm tra lại!",
    ManagerUnitHasArise:
      "Đơn vị quản lý đã có phát sinh dữ liệu, bạn không thể bỏ check là đơn vị quản lý.",
    ManagerUnitHasDependent:
      "Đơn vị đã có phát sinh đơn vị con là đơn vị quản lý, bạn không thể bỏ check là đơn vị quản lý.",
  },
};
